<template>
	<ui-button class="w-min border-gray-300 border font-medium rounded-lg p-1 px-2 text-sm cursor-pointer hover:text-slate-500" >
		<slot/>
	</ui-button>
</template>
